var C = /* @__PURE__ */ ((_) => (_.CLICK_ON_CTA = "click_on_cta", _.CLICK_ON_STORE = "click_on_store", _.CLICK_ON_IMAGE = "click_on_image", _.CLICK_ON_TITLE = "click_on_title", _.CLICK_ON_SEE_DEAL_DETAILS = "click_on_see_deal_details", _.CLICK_TO_COPY_DEAL_COUPON_CODE = "click_to_copy_deal_coupon_code", _))(C || {});
export {
  C as SecondaryDealCardAction
};
